import { render } from "./loginKantuStandalone.vue?vue&type=template&id=6807963c&scoped=true&ts=true"
import script from "./loginKantuStandalone.vue?vue&type=script&lang=ts"
export * from "./loginKantuStandalone.vue?vue&type=script&lang=ts"

import "./loginKantuStandalone.vue?vue&type=style&index=0&id=6807963c&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6807963c"]])